import { render, staticRenderFns } from "./myClaim.vue?vue&type=template&id=a74dc54e&scoped=true"
import script from "./myClaim.vue?vue&type=script&lang=js"
export * from "./myClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74dc54e",
  null
  
)

export default component.exports